<template>
    <guest-layout>
        <loading-block v-if="loading" />
        <div class="wrap-login" v-else>
            <h3 class="font-weight-bold text-uppercase">Login</h3>

            <div class="pull-left full"  v-if="errors.messages.errors">  
                <div class="alert alert-danger alert-dismissible">
                    {{ errors.messages.errors }}   
                </div>
            </div> 

            <form v-on:keyup.enter="handleSubmit">
                <div class="form-group" :class="errors.messages.username ? 'has-error' : ''">
                    <input type="text" v-model="form.username" class="form-control custom-input"  aria-describedby="emailHelp" placeholder="Username atau email">
                    <span class="help-block" v-if="errors.messages.hasOwnProperty('username')">
                        <strong>{{ errors.messages.username }}</strong>
                    </span>  
                </div>
                <div class="form-group" :class="errors.messages.password ? 'has-error' : ''">
                    <input type="password" v-model="form.password" class="form-control custom-input" placeholder="Password" >
                    <span class="help-block" v-if="errors.messages.hasOwnProperty('password')">
                        <strong>{{ errors.messages.password }}</strong>
                    </span>
                </div>
                <div class="row mb-3">
                    <div class="col-6">
<!--                        <div class="form-check">-->
<!--                            <input type="checkbox" class="form-check-input" id="remember">-->
<!--                            <label class="form-check-label" for="remember">Ingatkan saya</label>-->
<!--                        </div>-->
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="{ name: 'lost-password' }" class="font-weight-bold text-dark">Lupa Password</router-link>
                    </div>
                </div>
            </form>
            <div class="recaptcha-wrap" v-if="failed >= 3">
                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                <span>Wajib diisi</span>
            </div>
            <button class="btn btn-primary main-button login-button" @click="handleSubmit" :disabled="form.recaptcha === '' && failed >= 3">Login</button>
            <hr/>
           <!--  <button class="btn btn-primary main-button facebook-login" @click="handleFacebook">
                <i class="bi bi-facebook"></i> <span class="ml-1">Daftar/Masuk Lewat Facebook</span></button>
            <br/> -->
            <button class="btn btn-primary main-button google-login" @click="handleGoogle">
                <i class="bi bi-google"></i> <span class="ml-1">Daftar/Masuk Lewat Google</span>
            </button>

            <div class="text-center mt-3">
                <p>Belum memiliki akun ? <br>
                    <router-link :to="{ name: 'register' }" class="font-weight-bold text-dark">Daftar Akun</router-link></p>
            </div>
        </div>
    </guest-layout>
</template>
<script>
import axios from 'axios';
import $ from 'jquery';
import VueRecaptcha from 'vue-recaptcha';

export default {
    components: { VueRecaptcha },
    data() {
        return {
            errors: {
                messages: {
                    username:'',
                    password:'',
                    recaptcha:'',     
                },
            },
           
            failed: 0,
            form: {
                _token:'',
                username: '',
                password: '',
                recaptcha: ''
            },
            recaptcha: true,
            loading: false
        }
    },
    async mounted () {
        await this.loadFacebook()
    },
    methods: {
        async handleSubmit(event) {
            this.loading = true;
            // this.errors = [];
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            this.form._token = csrfToken;
            await axios.post('/login', this.form)
            .then(async (response) => {
                //
                this.$cookies.set('token', response.data.token, null, null, null,true);
                this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
               // this.$router.replace({name: 'home'});
                this.$cookies.set('sso_data', response.data.sso_data, null, null, null, true, 'None');
                 
                if(response.data.user.register_log =='arkadiame')
                {
                   this.$router.replace({name: 'home'});
                }else{
                   this.$router.replace({name: 'profile'});
                } 

                // Handle login sso
                //await this.handleSso(response.data.url);
            })
            .catch((error) => {
                this.loading = false;
                if(this.failed >= 3) {
                    this.$refs.recaptcha.reset();
                }
                if(error.response) {
                    this.recaptcha = true
                    if(error.response.status === 422) {
                        this.errors = error.response.data.errors
                        if(error.response.data.errors.hasOwnProperty('recaptcha')) {
                            this.failed = 3;
                        }
                    } else if (error.response.status === 401) {
                        this.failed++;
                    }
                    
                    this.errors = error.response.data;
                    if(this.errors.messages.errors)
                    {
                       setTimeout(() => {
                            this.errors =  {
                                messages: {
                                    username:'',
                                    password:'',
                                    recaptcha:'',
                                    errors:'',
                                },
                            };

                        } , 10000);

                    } 
                }
            });
        },
        async handleGoogle () {
            const googleUser = await this.$gAuth.signIn()
            if(googleUser) {
                const auth = googleUser.getAuthResponse()
                const status = await this.sendToApiSocial(auth.access_token, 'google')
                if(status) {
                    await this.$gAuth.signOut();
                }
            }
        },
        async sendToApiSocial (token, type) {
            this.loading = true;
            axios.post('/login-social?ref=arkadiame', {type: type, token: token})
            .then((response) => {
                // Handle login sso
                if (response.data.status === false) {
                    this.$router.push('register?type='+ type + '&id='+ token);
                } else {
                    //Handle login sso
                    this.$cookies.set('token', response.data.token, null, null, null,true, 'None');
                    this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
                    this.$cookies.set('sso_data', response.data.sso_data, null, null, null, true, 'None');
                   // this.handleSso(response.data.url);
                    this.$router.replace({name: 'home'});
                    return true;
                }
            })
            .catch((error) => {
                
                this.loading = false;
                this.errors = error.response.data;
                if(this.errors.messages.errors)
                {
                   setTimeout(() => {
                        this.errors =  {
                            messages: {
                                username:'',
                                password:'',
                                recaptcha:'',
                                errors:'',
                            },
                        };

                    } , 10000);

                } 

                return false;
            });
        },
        async handleFacebook() {
            window.FB.login(async (response) => {
                if (response.authResponse) {
                    const status = await this.sendToApiSocial(response.authResponse.accessToken, 'facebook')
                    if(status) {
                        this.handleFacebookLogout()
                    }
                }
            }, {scope: 'email,public_profile'});
            return false;
        },
        async handleFacebookLogout() {
            window.FB.logout(async (response) => {
                if (response) {
                    // Handle response
                }
            });
        },
        async loadFacebook() {
            await this.loadFacebookSDK(document, "script", "facebook-jssdk");
            await this.initFacebook();
        },
        async initFacebook() {
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: "1130575790808047",
                    cookie: true,
                    version: "v15.0"
                });
            };
        },
        async loadFacebookSDK(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        async handleSso(url) {
            await url.forEach(async (item) => {
                await $.getScript(item.url.toString())
                    .done(( script, textStatus ) => {
                        // totalRun = totalRun +1
                        // console.log(textStatus)
                    })
                    .fail(( jqxhr, settings, exception ) => {
                        // totalRun = totalRun +1
                    });
            });
        }
    }
}
</script>
<style>
.wrap-login {
    padding: 4%;
    margin-top: 15px;
}
.col-6 {
    flex: none!important;
    max-width: none!important;
}
.alert-danger {
    background-color: #dd4b39 !important;
    color: #fff !important;
    border-color: #d73925;
}

.pull-left{
    float: left;
}

.full{
    width: 100%;
}

.alert-dismissible {
    padding-right: 35px;
}
.alert {
    margin: 10px 0px;
    border: 1px solid transparent;
    border-radius: 3px;

}

.has-error .checkbox, .has-error .checkbox-inline, .has-error .control-label, .has-error .help-block, .has-error .radio, .has-error .radio-inline, .has-error.checkbox label, .has-error.checkbox-inline label, .has-error.radio label, .has-error.radio-inline label {
    color: #a94442;
}

</style>
